export default __webpack_public_path__ + "images/c9c4622c0b54fe5dc981f02e897f835d-home.webp";